document.addEventListener("DOMContentLoaded", () => {
  const CHAR_LIMIT = 2500;

  const container = document.getElementById(
    "collection_meta_description_footer"
  );

  if (!container) {
    console.warn("Container not found for description toggle");
    return;
  }

  const textBody = container.querySelector(
    ".collection__description_bottom-body"
  );
  const toggleButton = container.querySelector(
    ".collection__description_bottom-button"
  );

  if (!textBody || !toggleButton) {
    console.warn("Required elements not found for description toggle");
    return;
  }

  const toggleVisibility = () => {
    const isNowExpanded = container.classList.toggle("opened");
    toggleButton.setAttribute("aria-expanded", isNowExpanded);
    toggleButton.textContent = isNowExpanded
      ? toggleButton.dataset.showLessText
      : toggleButton.dataset.showMoreText;
  };

  const persistentVisibility = () => {
    container.classList.add("opened");
    toggleButton.setAttribute("aria-expanded", "true");
    toggleButton.textContent = toggleButton.dataset.showLessText;
  };

  toggleButton.addEventListener("click", toggleVisibility);

  const anchors = textBody.querySelectorAll('a[href^="#"]');
  anchors.forEach((anchor) =>
    anchor.addEventListener("click", persistentVisibility)
  );

  if (textBody.textContent.length < CHAR_LIMIT) {
    container.classList.add("opened");
    toggleButton.setAttribute("aria-expanded", "true");
    toggleButton.style.display = "none";
  }
});
